export const GET_GUARDIAN_INVOICES = 'GET_GUARDIAN_INVOICES';
export const SET_GUARDIAN_INVOICES = 'SET_GUARDIAN_INVOICES';
export const UPDATE_GUARDIAN_INVOICE = 'UPDATE_GUARDIAN_INVOICE';
export const SET_GUARDIAN_INVOICE = 'SET_GUARDIAN_INVOICE';
export const SET_GUARDIAN_INVOICES_SETTINGS = 'SET_GUARDIAN_INVOICES_SETTINGS';
export const GENERATE_GUARDIAN_INVOICES = 'GENERATE_GUARDIAN_INVOICES';
export const RECALCULATE_GUARDIAN_INVOICES = 'RECALCULATE_GUARDIAN_INVOICES';
export const GET_GUARDIAN_INVOICE = 'GET_GUARDIAN_INVOICE';
export const SET_ACTIVE_INVOICE = 'SET_ACTIVE_INVOICE';
export const SET_GUARDIAN_INVOICE_MONTH = 'SET_GUARDIAN_INVOICE_MONTH';
export const PUBLISH_GUARDIAN_INVOICES = 'PUBLISH_GUARDIAN_INVOICES';
